import { render, staticRenderFns } from "./GreatSuccess.vue?vue&type=template&id=66b785f0&scoped=true&"
import script from "./GreatSuccess.vue?vue&type=script&lang=js&"
export * from "./GreatSuccess.vue?vue&type=script&lang=js&"
import style0 from "./GreatSuccess.vue?vue&type=style&index=0&id=66b785f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b785f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VMain})
